import { ErrorBoundary } from '@sentry/react';
import { Box, FlexBox, Rhythm, Text } from '@trmediaab/zebra';
import { memo } from 'react';

import Ad from '~/components/Ad';
import RoundNavigation from '~/components/RoundNavigation';

import ChronicleTeaser from './ChronicleTeaser';
import NewsTeaser from './NewsTeaser';
import TVTeaser from './TVTeaser';

export default memo(TeaserList);

const articleRenderers = {
  chronicle: ChronicleTeaser,
  news_article: NewsTeaser,
  round_analysis: NewsTeaser,
  tv: TVTeaser,
};

export function createTeaser(data, blockIndex, teaserIndex, round) {
  if (!articleRenderers.hasOwnProperty(data.type)) {
    console.warn('Unknown article type:', data.type);
    return;
  }

  const Renderer = articleRenderers[data.type];

  return (
    <ErrorBoundary key={`block-${blockIndex}-${data.type}-${data.id}`}>
      <Renderer
        data={data}
        showImage={
          teaserIndex === 0 &&
          (data.image || data.teaser_image) &&
          ['round_analysis', 'news_article'].includes(data.type)
        }
        round={round}
      />
    </ErrorBoundary>
  );
}

function NewsBlockHeader() {
  return (
    <FlexBox bg="brands.travrondenSpel" px="3" py="3">
      <Text fontWeight="bold" color="white">
        Nyheter
      </Text>
    </FlexBox>
  );
}

function TeaserList({ data }) {
  return (
    <FlexBox
      flexDirection="column"
      gap={{ _: 4, lg: 5 }}
      bg="background.secondary"
      flex={1}
    >
      {data?.results?.map((block, blockIndex) => {
        switch (block.block_type) {
          case 'round':
            return (
              <FlexBox
                flexDirection="column"
                key={`round-block-${blockIndex}-${block.round.id}`}
              >
                <Box>
                  <RoundNavigation
                    round={block.round}
                    slug={block.round.slug}
                    variant="feed"
                  />
                </Box>
                <Rhythm between={1}>
                  {block.data.map((data, teaserIndex) =>
                    createTeaser(data, blockIndex, teaserIndex, block.round),
                  )}
                </Rhythm>
              </FlexBox>
            );

          case 'news':
            return (
              <Box key={`news-block-${blockIndex}`}>
                <NewsBlockHeader />

                <Rhythm between={1} pb={{ _: 4, lg: 5 }}>
                  {block.data.map((data, teaserIndex) =>
                    createTeaser(data, blockIndex, teaserIndex),
                  )}
                </Rhythm>
                <Ad placement="feed1" />
              </Box>
            );

          default:
            console.warn('TeaserList unknown block_type', block.block_type);
            return null;
        }
      })}
    </FlexBox>
  );
}
